import { createSlice } from "@reduxjs/toolkit";
import { extractRolesFromToken } from "../../utils/extractRolesFromToken.js";
import { isTokenValid } from "../../utils/validateToken.js";

// Initialize state from localStorage if available
const loadInitialState = () => {
  try {
    const storedAuth = localStorage.getItem("auth");
    if (!storedAuth) {
      return {
        profile: null,
        roles: [],
        token: null,
        isAuthenticated: false,
      };
    }

    const { user, token } = JSON.parse(storedAuth);
    
    // Validate token before restoring
    if (token && user && isTokenValid(token)) {
      const roles = extractRolesFromToken(token);
      return {
        profile: user,
        roles: roles || [],
        token: token,
        isAuthenticated: true,
      };
    } else {
      // Token is invalid or expired, clear storage
      localStorage.removeItem("auth");
      localStorage.removeItem("token");
      return {
        profile: null,
        roles: [],
        token: null,
        isAuthenticated: false,
      };
    }
  } catch (err) {
    console.error("Failed to load initial auth state", err);
    // Clear corrupted data
    localStorage.removeItem("auth");
    localStorage.removeItem("token");
    return {
      profile: null,
      roles: [],
      token: null,
      isAuthenticated: false,
    };
  }
};

const initialState = loadInitialState();

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { user, roles, token } = action.payload;

      state.profile = user;
      state.roles = roles;
      state.token = token;
      state.isAuthenticated = true;
    },

    logout: (state) => {
      state.profile = null;
      state.roles = [];
      state.token = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;
